import React, { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, Box, Typography, InputAdornment, IconButton
} from '@mui/material';

export const DocumentPasscodeModal = ({ open, onClose, onConfirm, docName }) => {
    const [passcode, setPasscode] = useState('');
    const [showPasscode, setShowPasscode] = useState(false);

    const handleSubmit = (e) => {
        if (e) e.preventDefault();
        onConfirm(passcode);
        setPasscode(''); // Clear for next use
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{ sx: { borderRadius: '20px', width: '100%', maxWidth: '350px', p: 1 } }}
        >
            <DialogTitle sx={{ textAlign: 'center', pb: 0 }}>
                <Box sx={{
                    width: 50, height: 50, bgcolor: 'rgba(21, 18, 105, 0.05)',
                    borderRadius: '50%', display: 'inline-flex', alignItems: 'center',
                    justifyContent: 'center', mb: 2
                }}>
                    <i className="icon-lock" style={{ color: '#151269', fontSize: '24px' }} />
                </Box>
                <Typography sx={{ fontWeight: 800, color: '#151269', fontSize: '18px' }}>
                    Secure Document
                </Typography>
            </DialogTitle>

            <form onSubmit={handleSubmit}>
                <DialogContent sx={{ textAlign: 'center', pt: 1 }}>
                    <Typography variant="body2" sx={{ color: '#666', mb: 3 }}>
                        Please enter the passcode to unlock: <br/>
                        <strong>{docName}</strong>
                    </Typography>

                    <TextField
                        fullWidth
                        autoFocus
                        type={showPasscode ? "text" : "password"}
                        placeholder="Enter Passcode"
                        value={passcode}
                        onChange={(e) => setPasscode(e.target.value)}
                        variant="outlined"
                        InputProps={{
                            sx: { borderRadius: '12px', bgcolor: '#f8f9fa' },
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPasscode(!showPasscode)} edge="end">
                                        <i className={showPasscode ? "icon-eye-blocked" : "icon-eye"} style={{fontSize: '16px'}} />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </DialogContent>

                <DialogActions sx={{ p: 2, justifyContent: 'center', gap: 1 }}>
                    <Button onClick={onClose} sx={{ color: '#888', fontWeight: 700 }}>Cancel</Button>
                    <Button
                        type="submit"
                        variant="contained"
                        disableElevation
                        sx={{
                            bgcolor: '#151269', borderRadius: '10px', px: 4, fontWeight: 800,
                            '&:hover': { bgcolor: '#0a084d' }
                        }}
                    >
                        UNLOCK
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};